/*
(function(i,s,o,g,r,a,m) {
  i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*Date.now();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
*/
(function() {
  const metaTag = document.getElementsByName("google-analytics-token");
  if (metaTag.length > 0) {
    window.dataAnalyticsLayer = window.dataAnalyticsLayer || [];
    function gtag(){dataAnalyticsLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', metaTag[0].content);
  }
})();
